import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { badge, dataLoading } from "../../../assets/assets";
import httpApiCall from "../../../service/api.service";
import { getStorageValue } from "../../../service/shared.service";
import toastr from "../../elements/toast";
import './details.scss'
import { savePartnerData } from "../../../Redux/Slices/MainSlice";
import { useDispatch } from "react-redux";

const CoursesDetails = () => {
	const dispatch = useDispatch();

	let [courseList, setCourseList] = useState([]);
	// const [scrollPercentage, setScrollPercentage] = useState(0);
	let [selectedIndex, setSelectedIndex] = useState(0);
	let [content, setContent] = useState(``);
	let [courseId, setCourseId] = useState(2);
	let [showQuiz, setShowQuiz] = useState(0);
	const toastrService = new toastr(true);
	const ref = useRef(null);
	const navigate = useNavigate();
	const [shimmer, setShimmer] = useState(false);
	const params = useParams();
	
	let getProfile: any = getStorageValue("partnerProfile");
	if (getProfile && getProfile.length) {
		getProfile = getProfile[0];
	}
	console.log(courseList,selectedIndex);
	
	useEffect(() => {
		document.addEventListener('click', handleClickOutside, true);
		const getCourses = async () => {
			const body = {
				access_token: getProfile.access_token
			}
			setShimmer(true);
			await httpApiCall({ api: "get_partner_courses", type: "post", body }).then(data => {
				setShimmer(false);
				if (!data.is_error) {
					setCourseList(data.data);
					if (params && params['course_id']) {
						courseId = Number(params['course_id']);
						courseList = data.data;
						setCourseId(courseId);
						setContentHtml(courseId);
					}
				} else {
					toastrService.showError('Something went wrong');
				}
			})
		}
		if (courseId == 2) {
			getCourses();
		}
	}, [courseId]);
	const handleClickOutside = (event: any) => {
		if (event.target && event.target.classList.contains('nextBTN')) {
			nextCourse();
		}
		if (event.target && event.target.classList.contains('prevBTN')) {
			prevCourse();
		}
    };
	const back = () => {
		navigate('/app/courses')
	}
	const setContentHtml = (courseIds: any) => {
		courseList.filter((ele: any) => {
			if (ele.course_id == courseIds) {
				showQuiz = ele.badge_status;
				content = ele.course_content
				selectedIndex = ele.course_order - 1;
				setSelectedIndex(selectedIndex);
				setContent(content);
				setShowQuiz(showQuiz);
				navigate(`/app/courses/details/${courseIds}`);
				return ele;
			}
		})
	}
	
	const startCourse = (course: any) => {
		// change element
		// selectedIndex = Number(course['course_order']);
		// setSelectedIndex(selectedIndex - 1);
		courseId = Number(course['course_id']);
		setCourseId(courseId);
		setContentHtml(course['course_id']);
		scrollToDiv('introduction');
	}
	const scrollToDiv = (divId: any) => {
		const divElement: any = document.getElementById(divId);
		if (divElement) {
			divElement.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
		}
		// const element = this._el.nativeElement.querySelector('#' + divId);
		// if (element) {
		//   element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
		// }
	}
	const quiz = () => {
		navigate(`/app/courses/quiz/${Number(params['course_id'])}`); 
	}
	const assets = () => {
		navigate(`/app/assets`); 
	}
	const prevCourse = () => {
		const nextCourseIdIndex = getPrevCourseId();
		navigate(`/app/courses/details/${courseList[nextCourseIdIndex]['course_id']}`); 
		startCourse(courseList[nextCourseIdIndex]);
	}
	const getPrevCourseId = () => {
		let index = courseList.findIndex((ele: any) => ele['course_id'] == courseId);
		if (index) {
			return --index;
		} else {
			return 0;
		}
	}
	const nextCourse = () => {
		const nextCourseIdIndex = getNextCourseId();
		navigate(`/app/courses/details/${courseList[nextCourseIdIndex]['course_id']}`); 
		startCourse(courseList[nextCourseIdIndex]);
	}

	const getNextCourseId = () => {
		const courseValue = Number(params && params['course_id'])
		let index = courseList.findIndex((ele: any) => ele['course_id'] == courseValue);
		return ++index;
	}
	const handleClick = (event: any) => {
    if (event.target.tagName === "BUTTON" && event.target.id === "takeQuiz") {
      quiz();
    }
    if (
      event.target.tagName === "BUTTON" &&
      event.target.classList.contains("prevCompleted")
    ) {
      const body = {
        access_token: getProfile.access_token,
        course_id: 9,
      };
      httpApiCall({ api: "add_course_badge_without_quiz", type: "post", body })
        .then((data) => {
          if (data && data.is_error == 0) {
            assets();
			dispatch(savePartnerData({ show_assets: data.data.is_badge_earn }));
          }
		  
        })
        .catch((error) => {
          console.log("error");
        });
    }
  };

	return (
		<>
			{
				shimmer ? <div className="no_data_v2 text-center">
					<img src={dataLoading} alt="" />
				</div> : (courseList && courseList.length > 0 &&
					<div className="course-details">
						<div className="courses-details-box">
							<>
								<div className="courses--left">
									<div className="back cursor">
										<a onClick={() => back()}><svg width="30" height="30" viewBox="0 0 30 30" fill="none"
											xmlns="http://www.w3.org/2000/svg">
											<rect width="30" height="30" rx="15" fill="#F2F5F8" />
											<path d="M12.7344 10.5L8.73437 15L12.7344 19.5" stroke="#131921" strokeWidth="1.5"
												strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
											<path d="M21.2578 15H9.25781" stroke="#131921" strokeWidth="1.5" strokeMiterlimit="10"
												strokeLinecap="round" strokeLinejoin="round" />
										</svg> <span>Back</span>
										</a>
									</div>

									<div className="courses--list">
										<span>All Courses:</span>
										<ul>
											{
												courseList.map((course: any, i) => (
													<li key={i}>
														<span className={selectedIndex == i ? 'active' : ''} 
														onClick={() => 
														startCourse(course)
														}>
															{course.course_training_name}
														</span>
													</li>
												))
											}

										</ul>
									</div>
								</div >
								<div onClick={handleClick} className={courseList && courseList[selectedIndex] && (courseList[selectedIndex]['course_order'] != 2 && courseList[selectedIndex]['course_order'] != 8) && !showQuiz  ? 'courses--middel showQuiz' : 'courses--middel '}>
									<div className="courses--html" dangerouslySetInnerHTML={{__html: content}}>
									</div>
								</div>
								<div className="courses--right">
									<ul>
										<li>
											<a onClick={() => scrollToDiv('introduction')}>Introduction
											</a>
										</li>
										<li>
											<a onClick={() => scrollToDiv('features')}>Features
											</a>
										</li>
										<li>
											<a onClick={() => scrollToDiv('advantages')}>Advantages
											</a>
										</li>
										<li>
											<a onClick={() => scrollToDiv('implementation')}>Implementation
											</a>
										</li>
									</ul>
									{courseList && courseList[selectedIndex] && (courseList[selectedIndex]['course_order'] != 2 && courseList[selectedIndex]['course_order'] != 8) && !showQuiz && <div className="quiz--box">
										<h6>Show your knowledge, Earn Badge</h6>
										<img src={badge} alt="" />
										<button id="take-Quiz" className="button" onClick={() => quiz()}>Take Quiz</button>
									</div>
									}
								</div>
							</>
						</div >
					</div>
				)
			}
		</>
	)
};

export default CoursesDetails;
